import type { InitOptions } from 'i18next'

export const defaultTranslationNS = 'translations'

const fallbackLng = 'en-US'

export enum LanguageSource {
  SameOriginHttp,
  LocalResources,
  ProdPanoramaHttp
}

export type TranslationOverrides = {
  source: LanguageSource
}

export const sharedTranslationInitOptions = {
  fallbackLng,
  debug: false,
  ns: [defaultTranslationNS, 'proto'],
  defaultNS: defaultTranslationNS,
  interpolation: {
    escapeValue: false // react already escapes to prevent xss
  },
  nsSeparator: '//',
  parseMissingKeyHandler: (_, fallback) => fallback,
  missingKeyNoValueFallbackToKey: true
} as const satisfies InitOptions

export const translationInitDetectionOptions = {
  order: [
    'querystring',
    'localStorage',
    'navigator',
    'cookie',
    'sessionStorage',
    'htmlTag',
    'path',
    'subdomain'
  ],
  lookupQuerystring: 'locale',
  excludeCacheFor: ['navigator'] // languages to not persist to local storage
}
